import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSigners = createSelector(
  [(store: RootState) => store.documentShow.signers],
  (signers) => {
    let arrayForSort = [...signers];
    arrayForSort.sort((a, b) => {
      if (a.order && b.order) {
        if (a?.order > b?.order) return 1;
        if (a?.order < b?.order) return -1;
        return 0;
      } else return 0;
    });
    return arrayForSort;
  }
);
